export const xGaokao = {
  subjectKinds: () => new Promise((resolve, reject) => {
    const resp = {
      body: [
        {
          name: 'wuli',
          label: '物理类',
          lineKind: 'RATE'
        },
        {
          name: 'lishi',
          label: '历史类',
          lineKind: 'RATE'
        }
      ]
    }
    for (let index = 0; index < resp.body.length; index++) {
      const element = resp.body[index];
      element.settings = getSettings()
    }
    resolve(resp)
  }),
  lineKinds: () => Promise.resolve({ body: getTips() }),
  getSubjectRouters: (query, which) => {
    const routers = [
      {
        path: '/basic',
        name: "基础成绩分析",
      },
      {
        path: '/levelAnalysis',
        name: "等级分析",
      },
      {
        path: '/scoreSection',
        name: "分数段占比",
      },
      {
        path: '/transcript',
        name: "成绩单",
      },
    ];
    const { type, newFlag, id, reportType, isRegion } = query;
    if (newFlag + '' === 'true') {
      routers.unshift({
        path: `/examBasic`,
        name: "考试概况"
      })
    }
    if (which) {
      const baseUrl = `/exam/gaokao/report/${id}/${which}`;
      const queryStr = `?type=${type}&newFlag=${newFlag}&reportType=${reportType}&isRegion=${isRegion}`
      for (let index = 0; index < routers.length; index++) {
        const element = routers[index];
        element.path = `${baseUrl}${element.path}${queryStr}`
      }
    }
    return routers
  }
}

function getSettings () {
  return [
    {
      kind: 'RATE',
      values: [
        {
          label: '特控线比例',
          value: 16
        },
        {
          label: '本科线比例',
          value: 50
        }
      ]
    },
    {
      kind: 'SCORE',
      values: [
        {
          label: '特控线分数',
          value: 595
        },
        {
          label: '本科线分数',
          value: 496
        }
      ]
    }
  ]
}

function getTips () {
  return [
    {
      unit: '%',
      label: '按比例设置',
      name: 'RATE',
      tipHtml: `特控线参考比例： <b style="color:#2877FF">16%</b><br/>
      （例：参加高考人数31.5万人，录取人数为5.32万人）<br/>
      本科线参考比例： <b style="color:#2877FF">50%</b><br/>
      （例：参加高考人数31.5万人，录取人数为15万人）<br/>
      *该分数线仅供参考，系统划线、赋分简介<br/>
      <a style="color:#2877FF" href="https://docs.qq.com/slide/DREhaTkROV3Z0SFdS" target="_blank">https://docs.qq.com/slide/DREhaTkROV3Z0SFdS</a>`
    },
    {
      unit: '分',
      label: '按分数设置',
      name: 'SCORE',
      tipHtml: `特控线参考分数线： <b style="color:#2877FF">595分</b><br/>
      （例：语数英：119分以上 物历政化生：79分以上）<br/>
      本科线参考分数线： <b style="color:#2877FF">496分</b><br/>
      （例：语数英：99分以上 物历政化生：66分以上）<br/>
      *该分数线仅供参考，系统划线、赋分简介<br/>
      <a style="color:#2877FF" href="https://docs.qq.com/slide/DREhaTkROV3Z0SFdS" target="_blank">https://docs.qq.com/slide/DREhaTkROV3Z0SFdS</a>`
    }
  ]
}